module.exports = __webpack_public_path__ + "ce78e84b710a3769315faf0aa884e820.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_2.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_2.png
// module chunks = 40